import { DashboardModule } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/no-data.svg'

const DataStoreBlankState = () => (
  <DashboardModule.BlankState imageUrl={BlankStateImageUrl}>
    <DashboardModule.BlankState.Title>
      No Data
    </DashboardModule.BlankState.Title>

    <DashboardModule.BlankState.Paragraph>
      You can collect or create data store content to suit any of the content your agency needs to collect
      and work with. This information can be used to present information to buyers and clients, populate agreements
      and other third party software platforms and more.
    </DashboardModule.BlankState.Paragraph>

    <DashboardModule.BlankState.Paragraph>
      To start collecting data you&apos;ll need to use a form, agreement or digital page template. Speak to support
      to discuss setting up data collection.
    </DashboardModule.BlankState.Paragraph>
  </DashboardModule.BlankState>

)

export default DataStoreBlankState
